var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.75001H11.3602C10.1826 3.84424 9.42567 5.31653 9.22098 6.91096C9.01629 8.50539 9.37678 10.1211 10.2398 11.4773C11.1028 12.8336 12.4138 13.8445 13.9448 14.3344C15.4759 14.8242 17.1302 14.7621 18.6202 14.1588C18.047 15.538 17.1103 16.7356 15.9098 17.6241C14.7093 18.5125 13.2902 19.0585 11.8038 19.2036C10.3174 19.3488 8.81945 19.0877 7.46978 18.4483C6.1201 17.8089 4.96932 16.8151 4.14017 15.5729C3.31102 14.3307 2.83462 12.8868 2.76177 11.3951C2.68893 9.90336 3.02238 8.41986 3.72655 7.10281C4.43073 5.78576 5.47921 4.68456 6.76016 3.91668C8.04111 3.1488 9.50649 2.74304 11 2.74268V2.75001Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 3.66669C15.5833 4.15292 15.7765 4.61923 16.1203 4.96305C16.4641 5.30687 16.9304 5.50002 17.4167 5.50002C16.9304 5.50002 16.4641 5.69317 16.1203 6.03699C15.7765 6.38081 15.5833 6.84712 15.5833 7.33335C15.5833 6.84712 15.3902 6.38081 15.0464 6.03699C14.7025 5.69317 14.2362 5.50002 13.75 5.50002C14.2362 5.50002 14.7025 5.30687 15.0464 4.96305C15.3902 4.61923 15.5833 4.15292 15.5833 3.66669Z",
    stroke: "#64748B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.16669V11M17.4167 10.0834H19.2501H17.4167Z",
    stroke: "#64748B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonStars);
export default __webpack_public_path__ + "static/media/moon-stars.f987aeffc3b4cbc2693731d6c88fb38f.svg";
export { ForwardRef as ReactComponent };